import EntSubs from './modules/00_entitlements.js';
import MembershipPrice from './modules/01_membership.js';
import Subscriber from './modules/02_subscriber.js';
import FilmUtility from './modules/03_film.js';
import './modules/04_oneTrust.js';

(function ($, Drupal) {
  if ($('.rentals.header-container [data-component-id="nuplayer:film_hero_carousel"]').length > 0) {
    $('[data-component-id="nuplayer:film_hero_carousel"]')
      .removeClass('initially-hidden')
      .addClass('show-if-non-subscription');
  }

  EntSubs.landingInit('rental');
  MembershipPrice.pageInit('rental');

  Subscriber.addUserStatusClasses();

  if ($('[data-component-id="nuplayer:full_width_page"].free').length > 0) {
    if ($('.free.header-container [data-component-id="nuplayer:film_hero_carousel"]').length > 0) {
      $('[data-component-id="nuplayer:film_hero_carousel"]')
        .removeClass('initially-hidden')
        .addClass('show-if-non-subscription');
    }
  }

  Drupal.behaviors.nuplayer = {
    EntSubs: EntSubs,
    MembershipPrice: MembershipPrice,
    Subscriber: Subscriber,
    FilmUtility: FilmUtility,
  };
})(jQuery, Drupal);
